<div class="chat-container">
    <!-- Fixed at top -->
    <pane-back-button [buttonFacingRight]="false" text="cancel" backToLeftPane="chat-bar"></pane-back-button>
    <div class="chat-header">
        <div class="d-flex w-100 justify-content-start align-items-center">
            <div class="profile-image-list-item">
                <base64-image [base64String]="chatImageBase64"></base64-image>
            </div>
            <div class="d-flex flex-column placeholder-glow">
                <div *ngIf="otherGuy" class="profile-name" [class.placeholder]="!otherGuy">{{ otherGuy?.display_name ?? "Loading..." }}</div>
                <div class="profile-status" [class.placeholder]="!otherGuy">{{ otherGuy?.tag_line ?? "Loading... Loading..." }}</div>
            </div>
        </div>
    </div>

    <!-- Scrollable middle section -->
    <div class="message-list" >
        <div class="welcome-msg my-5 mx-4 d-flex justify-content-center align-items-center">
            The beginning of your friendship
            <fa-icon class="mx-2" [icon]="iconsService.faIconsSolid.faSeedling"></fa-icon>
        </div>
    </div>

    <!-- Fixed at bottom, can grow -->
    <div class="new-message-bar">
    <textarea
            [(ngModel)]="newMessageText"
            placeholder="Type a message..."
            rows="1"
            (input)="autoResize($event)"
    ></textarea>
        <button class="btn btn-outline btn-send" (click)="sendMessage()">
            <fa-icon [icon]="iconsService.faIconsRegular.faPaperPlane"></fa-icon>
        </button>
    </div>
</div>
